<div *ngIf="expenseFacade.expenseSkeletonLoading$ | async">Loading...</div>
<div *ngIf="expenseFacade.expenseSkeletonLoaded$ | async">
  <div *ngIf="expenseFacade.expenseSkeleton$ | async as expenseSkeleton">
    <div *ngIf="expenseSkeleton.length > 0; else noExpenseSkeleton">
      <div *ngFor="let expense of expenseSkeleton">
        <sd-portal-audit-detail-list
          [isTall]="true"
          [loading]="expenseFacade.expenseAuditLoading$ | async"
          [loaded]="expenseFacade.expenseAuditLoaded$ | async"
          [audits]="expenseFacade.expenseAudit$ | async"
          [noAuditsMessage]="'No audit records for this expense'"
          (nextPage)="expenseFacade.loadNextPageExpenseAudit(expense.expenseId)"
        ></sd-portal-audit-detail-list>
      </div>
    </div>
    <ng-template #noExpenseSkeleton> No expenses to audit </ng-template>
  </div>
</div>
